import Main from './index.vue'

export default [
  {
    path: '/access', component: Main, meta: { auth: true },
  }
]